import { Button, Result } from "antd";
import i18n from "@/utils/i18n";
export function RejectedState(props: { onReapply: () => void }) {
  return (
    <Result
      status="warning"
      title={i18n.t("rejectedState.title")}
      subTitle={i18n.t("rejectedState.subTitle")}
      extra={<Button type="primary" onClick={props.onReapply}>{i18n.t("clientEducationDetail.cta.reapply")}</Button>}
    />
  );
}
